// @flow
/** @jsx jsx */

import { jsx } from '@emotion/core';
import {
  BooleanInput,
  GridCell,
  GridLayout,
  TruncatedText,
} from '@zapier/common-components';

import OnOffIndicator from 'app/common/components/OnOffIndicator';
import ZapStepIcons from 'app/common/components/ZapStepIcons';

import type { OnChooseZapType, ZapType } from 'app/zap-mover/types';

type Props = {
  ...$Exact<ZapType>,
  onChoose: OnChooseZapType,
  isSingleSelect: boolean,
};

const iconsCss = {
  gridArea: 'icons',
  width: 132,
};

const titleCss = {
  alignItems: 'center',
  display: 'flex',
  gridArea: 'title',
  maxWidth: '100%',
};

const wrapperCss = {
  cursor: 'pointer',
};

const ZapMoverZap = (props: Props) => {
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label css={wrapperCss}>
      <GridLayout
        alignItems="center"
        areas={`
          "input icons onoff"
          ". title title"
        `}
        columns="20px 1fr 40px"
        gap="0.75em"
        propsQueries={{
          'screen and (min-width: 500px)': {
            areas: "'input icons title onoff'",
            columns: '20px 132px minmax(0, 1fr) 40px',
          },
        }}
      >
        <GridCell area="input">
          <BooleanInput
            checked={props.isSelected}
            name="folderId"
            onChange={({ checked, value }) => props.onChoose(checked, value)}
            type={props.isSingleSelect ? 'radio' : 'checkbox'}
            value={props.id}
          />
        </GridCell>
        <div css={iconsCss}>
          <ZapStepIcons
            kind="small"
            max={3}
            steps={props.services.map(service => ({
              key: service,
              isPremium: false /* Unknown */,
              isHidden: false,
            }))}
          />
        </div>
        <div css={titleCss}>
          <TruncatedText>{props.title}</TruncatedText>
        </div>
        <GridCell area="onoff">
          <OnOffIndicator isOn={props.isOn} />
        </GridCell>
      </GridLayout>
    </label>
  );
};

export default ZapMoverZap;
